import { render, staticRenderFns } from "./BodyCell.vue?vue&type=template&id=ebc231b6"
import script from "./BodyCell.vue?vue&type=script&lang=js"
export * from "./BodyCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports